import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import React from 'react';
import CardText from 'react/shared/components/true_link/lab/form/wizard/CardText';
import TrueLinkCheckboxes from 'react/shared/components/true_link/main/form/TrueLinkCheckboxes';
import TrueLinkTextInput from 'react/shared/components/true_link/main/form/TrueLinkTextInput';
import ErrorText from 'react/signups/card/common/ErrorText';

const useStyles = makeStyles({
  rolesOtherTextbox: {
    margin: 0,
  },
});

export default function RolesForm({ onChange, setFieldValue, setFieldTouched, values }) {
  const classes = useStyles();

  const handleCheckboxCheck = (event) => {
    setFieldTouched('roles', true);
    if (event.target.checked) {
      setFieldValue('roles', values.roles.concat(event.target.name));
    } else {
      setFieldValue(
        'roles',
        values.roles.filter((name) => name !== event.target.name),
      );
    }
  };

  const options = [
    {
      label: 'Guardian or conservator',
      value: 'guardian',
    },
    {
      label: 'Fiduciary',
      value: 'fiduciary',
    },
    {
      label: 'Representative payee',
      value: 'rep-payee',
    },
    {
      label: 'Pooled trust',
      value: 'pooled-trust',
    },
    {
      label: 'Trust company or bank',
      value: 'trust-company-or-bank',
    },
    {
      label: 'Attorney',
      value: 'attorney',
    },
    {
      label: 'Care manager',
      value: 'care-manager',
    },
    {
      label: 'Residential community',
      value: 'residential-community',
    },
    {
      label: 'Recovery center',
      value: 'recovery',
    },
    {
      label: 'Other',
      value: 'other',
    },
  ];

  return (
    <>
      <CardText>You may wear many hats. Select all that apply.</CardText>
      <TrueLinkCheckboxes
        ariaLabel="administrator description"
        name=""
        onChange={handleCheckboxCheck}
        options={options}
        required
        value={values.roles}
      />
      {values.roles.includes('other') && (
        <TrueLinkTextInput
          className={classes.rolesOtherTextbox}
          name="rolesOther"
          onChange={onChange}
          placeholder="Briefly describe your role"
          required
          setFieldTouched={setFieldTouched}
          value={values.rolesOther}
        />
      )}
      <ErrorText name="roles" />
    </>
  );
}

RolesForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  values: PropTypes.shape({
    roles: PropTypes.array.isRequired,
    rolesOther: PropTypes.string.isRequired,
  }).isRequired,
};
